import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
import Spinner from "../components/Spinner/Spinner";

const UserRegistrationForm = dynamic(() =>
  import("../components/UserRegistration/UserRegistrationForm"),
  {
    ssr: false,
    loading: () => <Spinner />,
  }
);


const signup = () => {
  return (
    <Layout>
      <UserRegistrationForm />
    </Layout>
  );
};

export default signup;
